/**
 * Converts a base64 string to a Blob object.
 *
 * @param base64String The base64 encoded file data.
 * @param mimetype MIME type of the new Blob object.
 * @returns A Blob object representing the decoded file.
 */
export function base64ToBlob(base64String: string, mimetype?: string): Blob {
    const binaryString = window.atob(base64String);
    const bytes = new Uint8Array(binaryString.length);
    const mappedData = bytes.map((_byte, i) => binaryString.charCodeAt(i));

    return new Blob([mappedData], {
        type: mimetype,
    });
}
